var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "1792px",
    height: "1792px",
    viewBox: "590 -500 1792 1792",
    enableBackground: "new 590 -500 1792 1792",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bebebb",
    d: "M1294,876V172c0-9.3-3-17-9-23s-13.7-9-23-9h-64c-9.3,0-17,3-23,9s-9,13.7-9,23v704c0,9.3,3,17,9,23  s13.7,9,23,9h64c9.3,0,17-3,23-9S1294,885.3,1294,876z M1550,876V172c0-9.3-3-17-9-23s-13.7-9-23-9h-64c-9.3,0-17,3-23,9  s-9,13.7-9,23v704c0,9.3,3,17,9,23s13.7,9,23,9h64c9.3,0,17-3,23-9S1550,885.3,1550,876z M1806,876V172c0-9.3-3-17-9-23  s-13.7-9-23-9h-64c-9.3,0-17,3-23,9s-9,13.7-9,23v704c0,9.3,3,17,9,23s13.7,9,23,9h64c9.3,0,17-3,23-9S1806,885.3,1806,876z   M1262-116h448l-48-117c-4.7-6-10.3-9.7-17-11h-317c-6.7,1.3-12.3,5-17,11L1262-116z M2190-84v64c0,9.3-3,17-9,23s-13.7,9-23,9h-96  v948c0,55.3-15.7,103.2-47,143.5s-69,60.5-113,60.5h-832c-44,0-81.7-19.5-113-58.5s-47-86.2-47-141.5V12h-96c-9.3,0-17-3-23-9  s-9-13.7-9-23v-64c0-9.3,3-17,9-23s13.7-9,23-9h309l70-167c10-24.7,28-45.7,54-63s52.3-26,79-26h320c26.7,0,53,8.7,79,26  s44,38.3,54,63l70,167h309c9.3,0,17,3,23,9S2190-93.3,2190-84z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.31c19d6bfb0c24957e66afa4ec3d997d.svg";
export { ForwardRef as ReactComponent };